<template>
  <div class="col-span-full mx-auto max-w-[732px] p-4 min-[680px]:p-14 rounded-[15px] border border-solid border-[#E9E9E9] bg-white">
    <h1 class="text-t2 mb-4" v-if="isActivatingElectronicId">Identifiera dig med BankID</h1>
    <h1 class="text-t2 mb-4" v-else-if="isAccountPendingCreate">Snart är ditt konto klart</h1>

    <StepWizard v-if="isActivatingElectronicId || isAccountPendingCreate" :active-step="isActivatingElectronicId ? 5 : 6" />
    <Loader v-else-if="!isFetchingToken" />

    <div v-if="isActivatingElectronicId">
      <p class="text-b1 mb-8">För att slutföra din registrering behöver du du bekräfta din identitet. Det gör du genom att logga in på Mina sidor med BankID.</p>

      <div class="flex w-full justify-end mt-4">
        <Button size="extralarge" type="primary" :href="baseUrl + '/login/verify'" id="loginBtn">Logga in med BankID</Button>
      </div>
    </div>

    <div v-if="!isActivatingElectronicId && isAccountPendingCreate">
      <p>
        Ditt konto hos Gavlegårdarna håller på att skapas upp, det kan ta upp till några minuter.
        När det är klart loggas du in.
      </p>
      <Loader />
    </div>
    <div v-else-if="isFetchingToken">

    </div>
  </div>



  </template>

<script>
import auth from '@/auth/index';
import store from '@/store';
import { mapGetters } from 'vuex';
import { axios as axios_new_api } from '@/store/config';
import { AUTH_STATUSES } from '../../config/constants';
import Loader from '../ui/loader.vue';
import {LOGIN_METHODS} from '../../config/constants';
import Button from '@/components/ui/button';
import StepWizard from '@/components/ui/StepWizard';

export default {
  name: 'LoginCiam',
  components: {
    Button,
    StepWizard,
    Loader,
    ...mapGetters(['authStatus', 'getApiBaseUrl']),
  },
  data() {
    return {
      baseUrl: store.getters.getApiBaseUrl,
      isActivatingElectronicId: !!this.$route.query.bankid,
      isAccountPendingCreate: !!this.$route.query.pending,
      isFetchingToken: !!this.$route.query.nonce,
      fetchTokenFailed: false,
      showLoader: false,
    };
  },
  methods: {
    timeout: function (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    pollPending: async function () {
      this.showLoader = true;
      let response = await axios_new_api.get('/login/createaccountpending');

      while (!!response.data.status) {
        await this.timeout(3000);
        response = await axios_new_api.get('/login/createaccountpending').catch((error) => {
          console.log(error);
        });
      }
      const { nonce } = response.data;
      if (nonce) {
        this.$router.push({ name: 'LoginWithMethod', params: { loginMethod: LOGIN_METHODS.CIAM }, query: { nonce } });
      }

      this.showLoader = false;
    },
  },
  mounted() {
    this.$store.cache.clear();

    if (this.isAccountPendingCreate) {
      this.pollPending();
      return;
    }

    //get nonce vue paramaeter
    const nonce = this.$route.query.nonce;
    if (!nonce) {
      return;
    }

    this.pendingLogin = true;
    this.showLoader = true;
    const router = this.$router;
    axios_new_api
      .get('/login/GetToken?nonce=' + this.$route.query.nonce)
      .then(async (response) => {
        auth.setAuthToken(response.data.access_token);
        return this.$store.dispatch('setAuthStatus', AUTH_STATUSES.LOGGEDIN).then(() => {
          return this.$store.dispatch('setHasConfirmedMessagesOnboarding', response.data.hasConfirmedMessagesOnboarding).then(() => {
            this.$store.dispatch('setApplicantAuthData', response.data.applicant)
            this.$store.dispatch('setNewUser', response.data.applicant.firstLogin ?? false)
            this.pendingLogin = false;

            if(response.data.returnUrl && response.data.returnUrl !== "/") {
              window.location = response.data.returnUrl;
              return;
            }
            router.push({ name: 'Dashboard' });
            return response;
          });
        });
      })
      .catch((error) => {
        this.fetchTokenFailed = true;
        console.log(error);
        router.push({ name: 'Dashboard' });
      });
  },
};
</script>
